import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdatePrizeEntity } from '../../domain/entities/CreateUpdatePrizeEntity'

export class CreateUpdatePrizeModel extends CreateUpdatePrizeEntity {
  couponId?: number
  constructor(dataDto: CreateUpdatePrizeEntity) {
    super()
    mapEntityProperties<CreateUpdatePrizeModel>(this, dataDto, {
      exclude: ['coupon'],
      map: {
        couponId: dataDto.coupon?.id
      }
    })
  }
}
